import { Message, State } from "../types";

export interface PushMessageAction {
  message: Message;
  type: "PUSH MESSAGE";
}

export const pushMessage = (state: State, action: PushMessageAction): State => {
  const { message } = action;
  if (state.messages.some(m => m.id === message.id)) {
    return state;
  }
  return {
    ...state,
    messages: [...state.messages, message],
  };
};

export interface RemoveMessageAction {
  message: Message;
  type: "REMOVE MESSAGE";
}

export const removeMessage = (state: State, action: RemoveMessageAction): State => {
  const { message } = action;
  const newMessages = state.messages.filter(m => m.id !== message.id);
  if (newMessages.length === state.messages.length) {
    return state;
  }
  return {
    ...state,
    messages: newMessages,
  };
};
